/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon20Solid = forwardRef('MediaAudioVolumeSMinusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.933 2.285 4.632 6H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.632l4.301 3.715c.81.7 2.067.124 2.067-.946V3.23c0-1.07-1.257-1.645-2.067-.946Z" }),
        React.createElement("path", { d: "M13.25 9a1 1 0 1 0 0 2h5.5a1 1 0 0 0 0-2h-5.5Z" })));
});
